document.querySelectorAll('.multi-variant-input').forEach(input => {
  input.addEventListener('input', function () {
    const max = parseInt(this.max, 10);
    const min = parseInt(this.min, 10);
    let value = parseInt(this.value, 10);

    const wrapper = this.closest('.product')
  ?.querySelector('.product-form .product-form__error-message-wrapper');
    const errorEl = wrapper?.querySelector('.product-form__error-message');

    if (value > max) {
      this.value = max;
      if (wrapper && errorEl) {
        errorEl.textContent = `Aufgrund der Verfügbarkeit können nur ${max} Artikel zum Warenkorb hinzugefügt werden.`;
        wrapper.removeAttribute('hidden');
      }
    } else if (value < min) {
      this.value = min;
      if (wrapper && errorEl) {
        errorEl.textContent = `Aufgrund der Verfügbarkeit können nur ${min} Artikel zum Warenkorb hinzugefügt werden.`;
        wrapper.removeAttribute('hidden');
      }
    } else {
      if (wrapper && errorEl) {
        errorEl.textContent = '';
        wrapper.setAttribute('hidden', true);
      }
    }
  });
});
